import { css } from 'styled-system/css';

export const confirmModalStyles = {
	section: css({
		base: {
			justifyContent: 'center',
			md: {
				py: '84px',
			},
			'& .modalOverlay': {
				backdropFilter: 'none',
			}
		}
	}),
	modal: css({
		base: {
			w: '100%',
			maxW: '354px',
			borderRadius: '12px',
			zIndex: 'var(--modal-zindex)',
			overflow: 'hidden',
			bgColor: 'jupiter.grey.20',
		}
	}),
	header: css({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '12px 12px 0 0',
		borderBottom: '1px solid',
		borderBottomColor: 'jupiter.grey.40',
		bgColor: 'transparent',
		position: 'relative',
		w: '100%',
		h: '48px',
		color: 'jupiter.grey.80',
		textAlign: 'center',
		px: '12px',
	}),
	headerTitle: css({
		zIndex: 0,
		margin: '0',
		fontSize: '16px',
		fontWeight: '700',
	}),
	iconClose: css({
		base: {
			display: 'block',
			position: 'absolute',
			right: '12px',
			top: '8px',
			cursor: 'pointer',
			'& .icon': {
				color: 'jupiter.grey.50',
				w: '30px',
				h: '30px',
			},
		}
	}),
	root: css({
		display: 'flex',
		w: '100%',
		h: '100%',
		flexDirection: 'column',
		justifyContent: 'flex-start',
	}),
	content: css({
		borderRadius: '0 0 12px 12px',
		w: '100%',
		alignSelf: 'center',
		display: 'flex',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		overflowY: 'auto',
		flex: '1 1 0%',
	}),
	formContainer: css({
		alignSelf: 'flex-start',
		display: 'flex',
		minW: '240px',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start',
		w: '100%',
		p: '12px',
		gap: '24px',
	}),
	customText: css({
		flex: 1,
		borderRadius: '6px',
		w: '100%',
		h: '50px',
		fontSize: '14x',
		fontWeight: 500,
		textAlign: 'center'
	}),
	item: css({
		display: 'flex',
		justifyContent: 'space-between'
	}),
	infoKey: css({
		fontWeight: '500',
	}),
	infoValue: css({
		fontWeight: '700',
	}),
	buttonContainer: css({
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		gap: '6px',
	}),
	prevButton: css({
		minH: '36px',
		w: '100%',
		fontSize: '14px',
		fontWeight: '700',
		borderWidth: '1px',
		borderStyle: 'solid',
		borderRadius: '6px',
	}),
	nextButton: css({
		minH: '36px',
		w: '100%',
	}),
}